<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: Undo</title>
  <path
    d="
    M12,21
    a3 3 0 1 0 -4 -16
    l3 -3
    m-3 3
    l3 3
    "
    fill="none"
    stroke="black"
  />
</Icon>
